import ELEMENT from 'element-ui'
import modifyTable from './modifications/table'

modifyTable(ELEMENT)
export default ELEMENT
